import { CrudFormService } from '@/components/business/crud/service/CrudFormService';
import { markRaw } from 'vue';
import RuleForm from './RuleForm.vue';

export default class ProxyRuleForm extends CrudFormService {
  async init(): Promise<void> {
    await super.init();
    this.widgetContainer.updateField(
      'widget',
      {
        name: 'custom',
        component: markRaw(RuleForm),
        meta: { size: { edit: 'large', show: 'large' } },
      },
      ['directRule', 'blockRule']
    );
  }
}
